export default "__VITE_ASSET__uXjja4HT__"